<template>
  <article class="article-card">
    <NuxtLink :to="link" class="article-card__link">
      <div class="article-card__image-link">
        <NuxtImg
          v-if="image"
          :preload="false"
          :src="String(image)"
          :alt="title"
          class="article-card__image"
          loading="lazy"
          width="160"
          height="128"
        />
      </div>
      <div class="article-card__content">
        <LazyMagazineArticleCardMetaData
          v-if="author.trim()"
          :author="author"
          :date="date"
          context="articlePage"
        />

        <h2 class="article-card__title article-card__title-inner">
          {{ title }}
        </h2>

        <div class="article-card__text">
          {{ description }}
        </div>

        <div class="article-card__date">{{ date }}</div>
      </div>
    </NuxtLink>
  </article>
</template>

<script lang="ts" setup>
const { author, date, description, image, link, title } = defineProps<{
  image: string
  title: string
  description: string
  link: string
  author: string
  date: string
}>()
</script>

<style lang="css" scoped>
@reference '~/assets/css/tailwind.css';
.article-card {
  &__link {
    @apply flex gap-2;
  }

  &__image-link {
    @apply flex min-w-[160px] w-[160px] h-[128px] rounded-lg overflow-hidden;
  }

  &__image {
    @apply object-cover w-full h-full transition ease-in-out duration-500;

    .article-card__link:hover & {
      @apply scale-105;
    }
  }

  &__image-placeholder {
    @apply w-full h-full bg-gray-200 flex items-center justify-center;
  }

  &__image-icon {
    @apply w-8 h-8 text-gray-400;
  }

  &__content {
    @apply flex flex-col;
  }

  &__title {
    line-height: 125%;
  }

  &__title-inner {
    @apply text-sm font-medium m-0;

    display: inline;
    cursor: pointer;

    .article-card__link:hover & {
      @apply text-primary;
    }
  }

  &__text {
    @apply hidden md:[display:-webkit-box] my-1 text-xs text-stone-600;

    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__date {
    @apply mt-auto text-xs text-gray-500;
  }
}
</style>
